/**
 * popper placement 枚举
 */
export var placementEnum;

(function (placementEnum) {
  placementEnum["top"] = "top";
  placementEnum["topLeft"] = "top-start";
  placementEnum["topRight"] = "top-end";
  placementEnum["right"] = "right";
  placementEnum["rightTop"] = "right-start";
  placementEnum["rightBottom"] = "right-end";
  placementEnum["bottom"] = "bottom";
  placementEnum["bottomLeft"] = "bottom-start";
  placementEnum["bottomRight"] = "bottom-end";
  placementEnum["left"] = "left";
  placementEnum["leftTop"] = "left-start";
  placementEnum["leftBottom"] = "left-end";
})(placementEnum || (placementEnum = {})); // const direction = ['top', 'left', 'bottom', 'right'];
// const Placement: string[] = direction.reduce((pre, cur) => {
//     pre.push(cur, `${cur}-start`, `${cur}-end`);
//     return pre;
// }, []);


export var innerPlacement = ['top', 'topLeft', 'topRight', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom'];
export var Placement = innerPlacement;